const data = [
    { value: true, name: "Habilitado" },
    { value: false, name: "Desabilitado" },
]

export default [...data]